import React, { useState, useEffect } from "react";
import desktopLogo from "../../asset/landing-logo.png";
// import mobileLogo from "../asset/landing-lg.png";
import dropdown from "../../asset/landing-down.png";
import { Link } from "react-router-dom";

const LandingHeader = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);

  // Toggle menu open/close on smaller screens
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const [isPartnerOpen, setIsPartnerOpen] = useState(false);

  // Toggle function to show/hide dropdown
  const toggleDropdown = () => {
    setIsPartnerOpen(!isPartnerOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768);
      if (window.innerWidth > 768) {
        setIsOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#09839B",
    padding: "10px 20px",
    position: "sticky",
    top: 0,
    zIndex: 1000,
  };

  const logoStyle = {
    color: "white",
    fontSize: "24px",
    fontWeight: "bold",
  };

  const navLinksOverlayStyle = {
    display: isOpen ? "flex" : "none",
    flexDirection: "column",
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100vh",
    backgroundColor: "#09839B",
    justifyContent: "center",
    alignItems: "center",
    transition: "transform 0.3s ease-in-out",
    zIndex: 999,
  };

  const navLinksDesktopStyle = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  };

  const ulStyle = {
    listStyle: "none",
    padding: "0",
    margin: "0",
    display: "flex",
    flexDirection: isDesktop ? "row" : "column",
  };

  const liStyle = {
    margin: "10px 20px",
  };

  const linkStyle = {
    color: "white",
    textDecoration: "none",
    fontWeight: "500",
    fontSize: "18px",
  };

  const signUpButtonStyle = {
    backgroundColor: "white",
    color: "#09839B",
    border: "none",
    padding: "10px 20px",
    borderRadius: "30px",
    cursor: "pointer",
    fontSize: "16px",
    textDecoration: "none"
  };

  const hamburgerStyle = {
    display: "flex",
    flexDirection: "column",
    cursor: "pointer",
    marginRight: "10px",
  };

  const barStyle = {
    width: "25px",
    height: "3px",
    backgroundColor: "white",
    margin: "4px 0",
  };

  const mobileHeaderStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  };
  // const dropdown = {
  //   position: "relative",
  // }
  
  const dropdownContent  = {
    position: "absolute",
    backgroundColor: "#ffffff",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
    listStyle: "none",
    padding: "1rem 1.5rem",
    borderRadius:'10px',
    width: "250px",
    top: "35px",
    left: 0
  };

  const partnerMenu = {
   padding: '10px',
   borderBottom: '1px solid #ddd',
   cursor:'pointer',
  };

  const partnerLink = {
    textDecoration:'none',
    color:'#000',
   }

  
  return (
    <nav style={navStyle}>
      {/* Mobile Header Layout */}
      {!isDesktop ? (
        <div style={mobileHeaderStyle}>
          {/* Hamburger Icon */}
          <div
            style={hamburgerStyle}
            onClick={toggleMenu}
            aria-expanded={isPartnerOpen}
            aria-controls="nav-links"
          >
            <div style={barStyle}></div>
            <div style={barStyle}></div>
            <div style={barStyle}></div>
          </div>

          {/* Logo */}
          {/* <div style={logoStyle}>
            <img src={mobileLogo} style={{ width: "2.5rem" }} alt="Logo" />
          </div> */}

          {/* Sign Up Button */}
         <a href="https://www.youthplus.ng" style={signUpButtonStyle}>Sign Up</a> 
         
        </div>
      ) : (
        <>
          {/* Desktop Header Layout */}
          {/* Logo Section */}
          <div style={logoStyle}>
            <img src={desktopLogo} style={{ width: "13rem" }} alt="Logo" />
          </div>

          {/* Links Section */}
          <div style={navLinksDesktopStyle}>
            <ul style={ulStyle}>
              <li style={liStyle}>
                <a href="#features" style={linkStyle}>
                  Features{" "}
                  <span>
                    <img
                      src={dropdown}
                      style={{ height: "1.5rem" }}
                      alt="Dropdown"
                    />
                  </span>
                </a>
              </li>
              <li style={{...liStyle, position:"relative"}}>
                <a href="#partners" style={linkStyle}>
                  Partners{" "}
                </a>
                  <span onClick={toggleDropdown}>
                    <img
                      src={dropdown}
                      style={{ height: "1.5rem" }}
                      alt="Dropdown"
                    />
                  </span>
                  {isPartnerOpen && (
                    <ul style={dropdownContent}>
                      <li style={partnerMenu}><Link to="/nysc-onboarding" style={partnerLink} >NYSC</Link></li>
                      <li style={partnerMenu}><Link to= "/transport" style={partnerLink}>QuickTeller </Link></li>
                      <li style={partnerMenu}><Link to= "/complete-stanbicibtc-registration" style={partnerLink} >Stanbic IBTC</Link></li>
                      <li style={partnerMenu}><a href="https://productdive.com/productmanagementlaunchpad/" style={partnerLink}>Product Dive</a></li>

                    </ul>
                  )}
              </li>
              <li style={liStyle}>
                <a href="https://www.youthplus.ng/blogs" target="blank" style={linkStyle}>
                  Blog
                </a>
              </li>
              <li style={liStyle}>
                <a href="https://www.youthplus.ng/jobs" style={linkStyle}>
                  Jobs
                </a>
              </li>
              {/* <li style={liStyle}>
                <a href="#faqs" style={linkStyle}>
                  FAQs
                </a>
              </li> */}
              {/* <li style={liStyle}>
                <a href="#help-center" style={linkStyle}>
                  Help Center
                </a>
              </li> */}
            </ul>
          </div>

          {/* Sign Up Button */}
          <div>
          <a href="https://www.youthplus.ng" style={signUpButtonStyle}>Sign Up</a> 
          </div>
        </>
      )}

      {!isDesktop && (
        <div style={navLinksOverlayStyle}>
          <button
            onClick={toggleMenu}
            style={{
              position: "absolute",
              top: "20px",
              right: "20px",
              background: "none",
              border: "none",
              color: "white",
              fontSize: "24px",
              cursor: "pointer",
            }}
          >
            &times; {/* Close icon */}
          </button>
          <ul style={ulStyle}>
            <li style={liStyle}>
              <a href="#features" style={linkStyle}>
                Features
              </a>
            </li>
            <li style={liStyle}>
              <a href="#partners" style={linkStyle}>
                Partners
              </a>
            </li>
            <li style={liStyle}>
              <a href="https://www.youthplus.ng/blogs" target="blank" style={linkStyle}>
                Blog
              </a>
            </li>
            <li style={liStyle}>
              <a href="https://www.youthplus.ng/jobs" style={linkStyle}>
                Jobs
              </a>
            </li>
            {/* <li style={liStyle}>
              <a href="#faqs" style={linkStyle}>
                FAQs
              </a>
            </li>
            <li style={liStyle}>
              <a href="#help-center" style={linkStyle}>
                Help Center
              </a>
            </li> */}
          </ul>
        </div>
      )}
    </nav>
  );
};

export default LandingHeader;
